import { useLayoutEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { useDispatch, useSelector } from 'store/hooks';
import Navbar from 'components/navbar';
import Loading from 'components/loading';
import styles from './styles.module.scss';

const ApplicationCollateralLayout = () => {
  const { id } = useParams();

  const dispatch = useDispatch();
  const contextApplication = useSelector((state) => state.applicationCollateral);

  useLayoutEffect(() => {
    dispatch.applicationCollateral.FETCH_APPLICATION_BY_ID(id);
  }, [dispatch.applicationCollateral, id]);

  return (
    <div className={styles.applicationLayout} id="application-layout">
      {contextApplication.pending && (
        <div className={styles.loading}>
          <Loading />
        </div>
      )}
      {!contextApplication.pending && (
        <div className={styles.container}>
          <div className={styles.navbar}>
            <Navbar resultBlocked={contextApplication.data?.scoring_gold_log === null} collateral />
          </div>
          <div className={styles.content}>
            <Outlet />
          </div>
        </div>
      )}
    </div>
  );
};

export default ApplicationCollateralLayout;
